import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoLogoWhatsapp,
} from "react-icons/io";
import { useNavigate } from "react-router";
import "../../../sidebar.css";

import {
  FcCamcorderPro,
  FcCalculator,
  FcAndroidOs,
  FcMindMap,
  FcClock,
  FcMoneyTransfer,
  FcBusinessman,
  FcCalendar,
  FcFaq,
  FcRatings,
  FcGenealogy,
  FcPuzzle,
  FcSurvey,
  FcPositiveDynamic,
  FcAreaChart,
  FcCallTransfer,
  FcBullish,
  FcCustomerSupport,
  FcFeedIn,
  FcProcess,
  FcPhone,
  FcLandscape,
  FcManager,
  FcCircuit,
  FcWorkflow,
  FcFinePrint,
  FcIntegratedWebcam,
  FcPanorama,
  FcReading,
  FcCollect,
  FcCurrencyExchange,
  FcLineChart,
  FcDocument,
  FcInspection,
  FcCloseUpMode,
  FcStackOfPhotos,
  FcBiomass,
  FcDam,
  FcConferenceCall,
  FcInTransit,
  FcSalesPerformance,
  FcReuse,
  FcTemplate,
  FcShop,
  FcInvite,
  FcRules,
  FcCollaboration,
  FcPlanner,
  FcPortraitMode,
  FcWikipedia,
  FcSms,
  FcDeployment,
  FcPaid,
  FcComboChart,
  FcPackage,
  FcPieChart,
  FcEngineering,
  FcFeedback,
  FcKindle,
  FcImport,
  FcNews,
  FcFlowChart,
  FcOk,
  FcElectricalThreshold,
  FcComments,
  FcReadingEbook,
  FcMms,
  FcCopyright,
  FcElectronics,
  FcGrid,
  FcCallback,
  FcVoicePresentation,
  FcMultipleInputs,
  FcServiceMark,
  FcMultipleCameras,
  FcSelfServiceKiosk,
  FcVideoFile,
  FcOrganization,
  FcBearish,
  FcCellPhone,
  FcClapperboard,
  FcCompactCamera,
  FcFilmReel,
  FcEditImage,
  FcDisapprove,
  FcNeutralTrading,
  FcSettings,
  FcStatistics,
  FcAcceptDatabase,
  FcAlarmClock,
  FcAdvance,
} from "react-icons/fc";
import { PiListFill, PiPlantLight, PiPottedPlantDuotone } from "react-icons/pi";

import {
  MdOutlineInventory,
  MdOutlineTipsAndUpdates,
  MdPestControl,
  MdWorkOutline,
} from "react-icons/md";
import { BsDashCircle, BsRocket } from "react-icons/bs";
import { CeaNvphPricingIcon, TicketIcon } from "../layouts/icon";
import { HiOutlineBriefcase, HiOutlineDocumentText } from "react-icons/hi";
import { FaFileInvoiceDollar } from "react-icons/fa";

const CheckShowNavBasedRole = (role, additionalRole) => {
  if (role === process.env.REACT_APP_ROLE_ADMIN_S) {
    return [
      "Internal",
      "Client Invoice",
      "SI-Feedback",
      "Farm Training",
      "Reimbursement Management",
      // "Campaign",
      "Quotation",
      "Sales",
      "Call Records",
      "Client",
      "Farm",
      "Farmer Partner",
      "Buyers Connect",
      "Workforce",
      "Purchase",
      "Agronomy",
      "Resources",
      "Employee Management",
      "Leave Management",
      "Attendence Management",
      "Internal FAQ",
      "Employee Feedback",
      "Quotation Matrix",
      "Custom Quotation",
      "Leads",
      "My Operator",
      "Leads FollowUp",
      "Call Tracking",
      "Enquiry",
      "Incentives",
      "Client Projects",
      "Site Inspection",
      "Handover",
      "Project Tracking",
      "Payment Tracking",
      "Expence Tracking",
      "Leads Tracking",
      "Client Feedback",
      "Nursery Management",
      "Farm Management",
      "Farm Agreement",
      "Water Management",
      "Buyers Management",
      "Nutrient Calculations",
      "Price Watcher",
      "Management",
      "Purchase Order",
      "GRN System",
      "Service Order",
      "Request For Quotation",
      "Delivery Challan",
      "Vendor Management",
      "Agronomy Wiki",
      "Farm Support",
      "Assets",
      "Inventory",
      "Task Management",
      "Mobile App",
      "Watsapp Logs",
      "Revenue Management",
      "Analytics",
      "Contract Buying",
      "Sales Updates",
      "Harvest Management",
      "Crop Schedule",
      "Labour Training",
      "Pest/Disease",
      "Hydrobuild",
      "Hydrobuild",
      "Employee Salary",
      "Hydroponic Material Planning",
      "Hydroponic Material Inventory",
      "CEA-NVPH Pricing",
      "Farmer Inventory",
      "Farmer Shop",
      "Farmer Orders",
      "CnF Inventory",
      "CnF Shop",
      "CnF Orders",
      "Kryzen Orders",
      "Farmer Partner Management",
      "Subsidy & Documents",
      "Orders Tally",
      "Orders Revenue",
      "Email Marketing",
      "Email Matrics",
      "Marketing List",
      "Employee Feedback",
      "Company Assets",
      "SI Updates",
      "SI Schedules",
      "Employee Eficiency Program",
      "Refund",
      "Webinar",
      "Account",
      "Estimate",
      "Credit Note",
      "Cricket Game",
      "Documentation",
      "Website Feature",
      "Completed Projects",
      "Sales Analytics",
      "Job Applications",
      "Agri Subsidy",
      "Financial Expense",
      "Farming Conference",
      "A. Structure Utilization",
      "Request For Payment",
      "Celebration",
      "Construction Designer",
      "Kryzen Store",
      "NHM Applicants",
      "Material Planning New",
      "Price Scrapper",
      "Scrum Meetings",
      "Farm Training Media",
      "My Scoreboard",
      "Training Tests",
      "Kit Tracking",
      "Society Onbording",
      "EPG",
      "Leads System",
      "Leads Closer",
      "Media & Marketing",
      "Podcast",
      "Reels / Shorts",
      "Informative Videos",
      "Graphics",
      "Guest Management",
      "Content Pipeline",
      "Posting Planning",
      "Creative Standards & Apps",
      "Concept & Ideas",
      "Courses",
      "Create Enquiry",
      "Cold Leads",
      "Vendor Buy Order",
      "MyOperator & JustDial Enquiries",
      "Master Leads",
      "Template Settings",
      "Campaign Stat",
      "Ai Call Logs",
      "Ai Bookings",
      "Interview Candidates",
      "Interview Scheduling Pipline",
      "Lead Transfer",
      "Proforma Invoice",
      "Request For Material",
      "Media Delivery",
      "PO & GRN Vendor Payment",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_ADMIN) {
    return [
      "Internal",
      "Client Invoice",
      "SI-Feedback",
      "Farm Training",
      "Reimbursement Management",
      // "Campaign",
      "Quotation",
      "Sales",
      "Call Records",
      "Client",
      "Farm",
      "Farmer Partner",
      "Buyers Connect",
      "Workforce",
      "Purchase",
      "Agronomy",
      "Resources",
      "Employee Management",
      "Leave Management",
      "Attendence Management",
      "Internal FAQ",
      "Employee Feedback",
      "Company Assets",
      "Quotation Matrix",
      "Custom Quotation",
      "Leads",
      "My Operator",
      "Leads FollowUp",
      "Call Tracking",
      // "Leads-Filtered",
      // "Cold Leads",
      "Enquiry",
      "Incentives",
      "Client Projects",
      "Site Inspection",
      "Handover",
      "Project Tracking",
      "Payment Tracking",
      "Expence Tracking",
      "Leads Tracking",
      "Client Feedback",
      "Nursery Management",
      "Farm Management",
      "Farm Agreement",
      "Water Management",
      "Buyers Management",
      "Nutrient Calculations",
      "Price Watcher",
      "Management",
      "Purchase Order",
      "GRN System",
      "Service Order",
      "Request For Quotation",
      "Delivery Challan",
      "Vendor Management",
      "Agronomy Wiki",
      "Farm Support",
      "Assets",
      "Inventory",
      "Task Management",
      "Revenue Management",
      "Harvest Management",
      "Crop Schedule",
      "Labour Training",
      "Pest/Disease",
      "Hydrobuild",
      "Employee Salary",
      "Hydroponic Material Planning",
      "Hydroponic Material Inventory",
      "CEA-NVPH Pricing",
      "Subsidy & Documents",
      "Orders Tally",
      "Orders Revenue",
      "Marketing List",
      "SI Updates",
      "SI Schedules",
      "Webinar",
      "Account",
      "Estimate",
      "Credit Note",
      "Cricket Game",
      "Documentation",
      "Website Feature",
      "Sales Analytics",
      "Mobile App",
      "Watsapp Logs",
      "Analytics",
      "Contract Buying",
      "Sales Updates",
      "Email Marketing",
      "Email Matrics",
      "Farmer Inventory",
      "Farmer Shop",
      "Farmer Orders",
      "CnF Inventory",
      "CnF Shop",
      "CnF Orders",
      "Kryzen Orders",
      "Farmer Partner Management",
      "Employee Eficiency Program",
      "Refund",
      "Completed Projects",
      "Sales Analytics",
      "Agri Subsidy",
      "Job Applications",
      "Farming Conference",
      "Financial Expense",
      "Job Applications",
      "A. Structure Utilization",
      "Request For Payment",
      "Celebration",
      "Construction Designer",
      "Kryzen Store",
      "NHM Applicants",
      "Material Planning New",
      "Price Scrapper",
      "Scrum Meetings",
      "Farm Training Media",
      "My Scoreboard",
      "Training Tests",
      "Kit Tracking",
      "Society Onbording",
      "EPG",
      "Leads System",
      "Leads Closer",
      "Media & Marketing",
      "Podcast",
      "Reels / Shorts",
      "Informative Videos",
      "Graphics",
      "Guest Management",
      "Content Pipeline",
      "Posting Planning",
      "Creative Standards & Apps",
      "Concept & Ideas",
      "Courses",
      "Create Enquiry",
      "Vendor Buy Order",
      "MyOperator & JustDial Enquiries",
      "Master Leads",
      "Template Settings",
      "Campaign Stat",
      "Ai Call Logs",
      "Ai Bookings",
      "Interview Candidates",
      "Interview Scheduling Pipline",
      "Lead Transfer",
      "Request For Material",
      "Media Delivery",
      "PO & GRN Vendor Payment",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_PURCHASE) {
    return [
      "Internal",
      "Reimbursement Management",
      "Quotation",
      "Client",
      "Purchase",
      "Resources",
      "Leave Management",
      "Internal FAQ",
      "Employee Feedback",
      "Company Assets",
      "Quotation Matrix",
      "Custom Quotation",
      "Client Projects",
      "Site Inspection",
      "Handover",
      "Project Tracking",
      "Payment Tracking",
      "Expence Tracking",
      "Purchase Order",
      "GRN System",
      "Service Order",
      "Request For Quotation",
      "Delivery Challan",
      "Vendor Management",
      "Assets",
      "Inventory",
      "Task Management",
      "Employee Salary",
      "Hydroponic Material Planning",
      "Hydroponic Material Inventory",
      "Subsidy & Documents",
      "Cricket Game",
      "Job Applications",
      "Request For Payment",
      "Kryzen Store",
      "Material Planning New",
      "Scrum Meetings",
      "My Scoreboard",
      "Construction Designer",
      "Employee Eficiency Program",
      "Request For Material",
      "PO & GRN Vendor Payment",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_SALLE) {
    return [
      "Internal",
      "Reimbursement Management",
      "Quotation",
      "Sales",
      "Call Records",
      "Leave Management",
      "Internal FAQ",
      "Employee Feedback",
      "Custom Quotation",
      // "Leads",
      "My Operator",
      // "Leads FollowUp",
      "Call Tracking",
      // "Leads-Filtered",
      "Farm Training",
      // "Incentives",
      // "Leads Tracking",
      "Client Feedback",
      "Task Management",
      "Revenue Management",
      "Employee Salary",
      "SI Updates",
      "SI Schedules",
      "Cricket Game",
      "Sales Analytics",
      "Construction Designer",
      "NHM Applicants",
      "Scrum Meetings",
      "Farm Training Media",
      "My Scoreboard",
      "Kit Tracking",
      "Proforma Invoice",
      "Leads System",
      "Leads Closer",
      "Employee Eficiency Program",
      "Create Enquiry",
      "Vendor Buy Order",
      "MyOperator & JustDial Enquiries",
      "Ai Bookings",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_SALLE_ADMIN) {
    return [
      "Internal",
      "Reimbursement Management",
      "Quotation",
      "Sales",
      "Call Records",
      "Leave Management",
      "Internal FAQ",
      "Employee Feedback",
      "Custom Quotation",
      // "Leads",
      "My Operator",
      // "Leads FollowUp",
      "Call Tracking",
      // "Leads-Filtered",
      "Farm Training",
      // "Incentives",
      // "Leads Tracking",
      "Client Feedback",
      "Task Management",
      "Revenue Management",
      "Employee Salary",
      "SI Updates",
      "SI Schedules",
      "Client",
      "Client Projects",
      "Site Inspection",
      "Subsidy & Documents",
      "Cricket Game",
      "Sales Analytics",
      "A. Structure Utilization",
      "Construction Designer",
      "NHM Applicants",
      "Buyers Connect",
      "Buyers Management",
      "Farm",
      "Nursery Management",
      "Farm Management",
      "Water Management",
      "Harvest Management",
      "Crop Schedule",
      "Labour Training",
      "Nutrient Calculations",
      "Price Watcher",
      "Agronomy",
      "Agronomy Wiki",
      "Pest/Disease",
      "Farm Support",
      "Resources",
      "Assets",
      "Inventory",
      "Farm Training Media",
      "Scrum Meetings",
      "My Scoreboard",
      "Handover",
      "Kit Tracking",
      "Proforma Invoice",
      "Leads System",
      "Leads Closer",
      "Employee Eficiency Program",
      "Create Enquiry",
      "Vendor Buy Order",
      "MyOperator & JustDial Enquiries",
      "Ai Bookings",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_SALESAGENCY) {
    return [
      "Internal",
      "Sales",
      "Call Records",
      "Internal FAQ",
      "Employee Feedback",
      // "Leads",
      "My Operator",
      // "Cold Leads",
      "Task Management",
      "Employee Salary",
      "SI Updates",
      "Cricket Game",
      "Sales Analytics",
      "NHM Applicants",
      "Scrum Meetings",
      "My Scoreboard",
      "Create Enquiry",
      "Vendor Buy Order",
      "MyOperator & JustDial Enquiries",
      "Ai Bookings",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_AGRONOMIST) {
    return [
      "Internal",
      "Reimbursement Management",
      "Farm",
      "Agronomy",
      "Resources",
      "Leave Management",
      "Buyers Management",
      "Price Watcher",
      "Internal FAQ",
      "Employee Feedback",
      "Buyers Connect",
      "Nursery Management",
      "Farm Management",
      "Farm Agreement",
      "Water Management",
      "Nutrient Calculations",
      "Agronomy Wiki",
      "Farm Support",
      "Assets",
      "Inventory",
      "Task Management",
      "Harvest Management",
      "Price Watcher",
      "Crop Schedule",
      "Labour Training",
      "Pest/Disease",
      "Employee Salary",
      "Cricket Game",
      "Scrum Meetings",
      "My Scoreboard",
      "Employee Eficiency Program",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_OPS) {
    return [
      "Internal",
      "Sales",
      "Farm Training",
      "Reimbursement Management",
      "Client",
      "SI-Feedback",
      "Farm",
      "Resources",
      "Workforce",
      "Nursery Management",
      "Farm Management",
      "Water Management",
      "Nutrient Calculations",
      "Agronomy Wiki",
      "Farm Support",
      "Agronomy",
      "Buyers Connect",
      "Buyers Management",
      "Leave Management",
      "Internal FAQ",
      "Employee Feedback",
      "Client Projects",
      "Site Inspection",
      "Handover",
      "Project Tracking",
      "Management",
      "Assets",
      "Inventory",
      "Task Management",
      "Harvest Management",
      "Price Watcher",
      "Crop Schedule",
      "Labour Training",
      "Pest/Disease",
      "Employee Salary",
      "SI Updates",
      "Cricket Game",
      "Scrum Meetings",
      "My Scoreboard",
      "Construction Designer",
      "Employee Eficiency Program",
      "Request For Material",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_INSPECTION) {
    return [
      "Internal",
      "Reimbursement Management",
      "Client",

      "Leave Management",

      "Internal FAQ",
      "Employee Feedback",

      "Site Inspection",
      "Handover",
      "Task Management",
      "Cricket Game",
      "Scrum Meetings",
      "My Scoreboard",
      "Employee Eficiency Program",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_MARKETING) {
    return [
      "Internal",
      "Reimbursement Management",
      "Buyers Connect",
      "Leave Management",

      "Internal FAQ",
      "Employee Feedback",

      "Buyers Management",

      "Price Watcher",
      "Task Management",
      "Employee Salary",
      "Cricket Game",
      "Scrum Meetings",
      "My Scoreboard",
      "Employee Eficiency Program",
    ];
  }

  if (
    role === process.env.REACT_APP_ROLE_CLIENT &&
    additionalRole === "farmer partner"
  ) {
    return [
      "Client",
      "Farm",
      // "Farmer Partner",
      "Buyers Connect",
      "Workforce",
      "Farm Support",
      "Agronomy",
      "Site Inspection",
      "Handover",
      "Project Tracking",
      "Payment Tracking",
      "Nursery Management",
      "Nutrient Calculations",
      "Water Management",
      "Buyers Management",
      "Management",
      "Agronomy Wiki",
      "Resources",
      "Assets",
      "Inventory",
      "Price Watcher",
      "Harvest Management",
      "Crop Schedule",
      "Labour Training",
      "Contract Buying",
      "Subsidy & Documents",
      "Farmer Inventory",
      "Farm Management",
      "Farmer Shop",
      "Farmer Orders",
      "Orders Tally",
      "Orders Revenue",
      "Cricket Game",
      "Scrum Meetings",
      "Applications",
      "Job Applications",
      "Society Onbording",
      "EPG Orders",
    ];
  }

  if (role === process.env.REACT_APP_ROLE_CLIENT) {
    return [
      "Client",
      "Farm",
      // "Farmer Partner",
      "Buyers Connect",
      "Workforce",
      "Farm Support",
      "Agronomy",
      "Site Inspection",
      "Handover",
      "Project Tracking",
      "Payment Tracking",
      "Nursery Management",
      "Farm Management",
      "Nutrient Calculations",
      "Water Management",
      "Buyers Management",
      "Management",
      "Agronomy Wiki",
      "Resources",
      "Assets",
      "Inventory",
      "Price Watcher",
      "Harvest Management",
      "Crop Schedule",
      "Labour Training",
      "Contract Buying",
      "Subsidy & Documents",
      "Cricket Game",
      "Pest/Disease",
      "Scrum Meetings",
      "Applications",
      "Job Applications",
      "Society Onbording",
      // "EPG Orders",
    ];
  }

  if (role === process.env.REACT_APP_ROLE_ACCOUNTS) {
    return [
      "Internal",
      "Internal FAQ",
      "Employee Salary",
      "Reimbursement Management",
      "Account",
      "Estimate",
      "Credit Note",
      "Client Invoice",
      "Expence Tracking",
      "Payment Tracking",
      "Price Watcher",
      "Cricket Game",
      "Scrum Meetings",
      "My Scoreboard",
      "Employee Eficiency Program",
      "Purchase",
      "Request For Quotation",
      "Delivery Challan",
      "Request For Payment",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_IT) {
    return [
      "Internal",
      "Internal FAQ",
      "Reimbursement Management",
      "Leave Management",
      "Task Management",
      "Employee Salary",
      "Employee Feedback",
      "Cricket Game",
      "Celebration",
      "Buyers Connect",
      "Price Scrapper",
      "Scrum Meetings",
      "My Scoreboard",
      "Employee Eficiency Program",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_SSM) {
    return [
      "Internal",
      "Internal FAQ",
      "Reimbursement Management",
      "Leave Management",
      "Task Management",
      "Employee Salary",
      "Employee Feedback",
      "Cricket Game",
      "Scrum Meetings",
      "My Scoreboard",
      "Media & Marketing",
      "Podcast",
      "Reels / Shorts",
      "Informative Videos",
      "Graphics",
      "Guest Management",
      "Employee Eficiency Program",
      "Content Pipeline",
      "Posting Planning",
      "Creative Standards & Apps",
      "Concept & Ideas",
      "Courses",
      "Media Delivery",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_SALES_MANAGER) {
    return [
      "Internal",
      "Reimbursement Management",
      "Quotation",
      "Sales",
      "Call Records",
      "Leave Management",
      "Internal FAQ",
      "Employee Feedback",
      "Custom Quotation",
      // "Leads",
      "My Operator",
      // "Leads FollowUp",
      "Call Tracking",
      // "Leads-Filtered",
      // "Cold Leads",
      "Farm Training",
      // "Incentives",
      // "Leads Tracking",
      "Client Feedback",
      "Enquiry",
      "Client",
      "Client Projects",
      "Site Inspection",
      "Project Tracking",
      "Farm",
      "Nursery Management",
      "Water Management",
      "Nutrient Calculations",
      "Buyers Connect",
      "Buyers Management",
      "Workforce",
      "Management",
      "Resources",
      "Assets",
      "Inventory",
      "Workforce",
      "Farm Support",
      "Agronomy",
      "Agronomy Wiki",
      "Task Management",
      "Revenue Management",
      "Harvest Management",
      "Crop Schedule",
      "Labour Training",
      "Pest/Disease",
      "Employee Salary",
      "SI Updates",
      "Cricket Game",
      "Sales Analytics",
      "Construction Designer",
      "Scrum Meetings",
      "My Scoreboard",
      "Kit Tracking",
      "Proforma Invoice",
      "Employee Eficiency Program",
      "Create Enquiry",
      "Vendor Buy Order",
      "MyOperator & JustDial Enquiries",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_CLIENT_FEEDBACK) {
    return [
      "Internal",
      "Reimbursement Management",
      "Quotation",
      "Sales",
      "Call Records",
      "Leave Management",
      "Internal FAQ",
      "Employee Feedback",
      "Custom Quotation",
      "Leads",
      "My Operator",
      "Leads FollowUp",
      "Call Tracking",
      // "Leads-Filtered",
      "Farm Training",
      // "Incentives",
      "Leads Tracking",
      "Client Feedback",
      "Task Management",
      "Employee Salary",
      "SI Updates",
      "Cricket Game",
      "Scrum Meetings",
      "My Scoreboard",
      "Employee Eficiency Program",
      "Create Enquiry",
      "Vendor Buy Order",
      "MyOperator & JustDial Enquiries",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_SITE_INSPECTION) {
    return ["Client", "Site Inspections", "Scrum Meetings"];
  }
  if (role === process.env.REACT_APP_ROLE_HR) {
    return [
      "Internal",
      "Reimbursement Management",
      "Resources",
      "Employee Management",
      "Leave Management",
      "Attendence Management",
      "Internal FAQ",
      "Employee Feedback",
      "Company Assets",
      "Assets",
      "Task Management",
      "Employee Salary",
      "Cricket Game",
      "Sales Analytics",
      "Analytics",
      "Job Applications",
      "Scrum Meetings",
      "Celebration",
      "My Scoreboard",
      "Training Tests",
      "Call Tracking",
      "Sales",
      "Buyers Connect",
      "Buyers Management",
      "Employee Eficiency Program",
      "MyOperator & JustDial Enquiries",
      "Media & Marketing",
      "Content Pipeline",
      "Posting Planning",
      "Client",
      "Project Tracking",
      "Leads System",
      "Leads Closer",
      "Interview Candidates",
      "Interview Scheduling Pipline",
      "Request For Material",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_JR_HR) {
    return [
      "Internal",
      "Reimbursement Management",
      "Resources",
      "Employee Management",
      "Leave Management",
      "Internal FAQ",
      "Employee Feedback",
      "Company Assets",
      "Assets",
      "Task Management",
      "Employee Salary",
      "Cricket Game",
      "Job Applications",
      "Scrum Meetings",
      "Celebration",
      "My Scoreboard",
      "Training Tests",
      "Call Tracking",
      "Sales",
      "Employee Eficiency Program",
      "Interview Candidates",
      "Interview Scheduling Pipline",
      "Request For Material",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_SALESCOORDINATOR) {
    return [
      "Internal",
      "Reimbursement Management",
      "Leave Management",
      "Internal FAQ",
      "Employee Feedback",
      "Task Management",
      "Employee Salary",
      "Client",
      "Buyers Connect",
      "Buyers Management",
      "Contract Buying",
      "Price Watcher",
      "Cricket Game",
      "Completed Projects",
      "Sales Analytics",
      "Scrum Meetings",
      "My Scoreboard",
      "Employee Eficiency Program",
    ];
  }
  if (role === process.env.REACT_APP_ROLE_OFFICE_STAFF) {
    return [
      "Internal",
      "Leave Management",
      "Employee Salary",
      "Scrum Meetings",
      "My Scoreboard",
      "Employee Eficiency Program",
    ];
  }
  if (role === "marketingAgency") {
    return ["Media Delivery", "Media & Marketing"];
  } else {
    return [];
  }
};

const Sidebarnew = () => {
  let role = useSelector((store) => store?.login?.user);
  const navigate = useNavigate();
  const [navBar, setNavBar] = useState([]);
  // const location = useLocation();
  // const endpoint = location.pathname;
  // const [activeNavItem, setActiveNavItem] = useState("");
  // const [isOpen, setIsOpen] = useState(false);
  // const baseURL = process.env.REACT_APP_BACKEND_BASEURL || "";
  // const isDev = baseURL.includes("localhost");
  // const isStaging = baseURL.includes("alpha-dev");
  // const showCricketGame = isDev || isStaging;

  useEffect(() => {
    if (role) {
      setNavBar(CheckShowNavBasedRole(role.Role, role.AdditionalRole));
    }
  }, [role]);

  // useEffect(() => {
  //   if (
  //     endpoint.includes("/employee-management") ||
  //     endpoint.includes("/reimbursement-management") ||
  //     endpoint.includes("/employee-leave-management") ||
  //     endpoint.includes("/employee-attendance") ||
  //     endpoint.includes("/internal-FAQ") ||
  //     endpoint.includes("/task-management") ||
  //     endpoint.includes("/android-app") ||
  //     endpoint.includes("/watsapp-logs") ||
  //     endpoint.includes("/employee-salary") ||
  //     endpoint.includes("/employee-payslip") ||
  //     endpoint.includes("/email-marketing") ||
  //     endpoint.includes("/edit-email-template") ||
  //     endpoint.includes("/create-email-template") ||
  //     endpoint.includes("/send-bulk-email") ||
  //     endpoint.includes("/marketing") ||
  //     endpoint.includes("/email-matrics") ||
  //     endpoint.includes("/employee-feedbacks") ||
  //     endpoint.includes("/employee-eficiency-program") ||
  //     endpoint.includes("/show-teams")
  //   ) {
  //     setActiveNavItem("Internal");
  //   } else if (
  //     endpoint.includes("/custom-quotation") ||
  //     endpoint.includes("/standard-quotation")
  //   ) {
  //     setActiveNavItem("Quotation");
  //   } else if (
  //     endpoint.includes("/farm-training") ||
  //     endpoint.includes("/leads") ||
  //     endpoint.includes("/enquiry") ||
  //     endpoint.includes("/revenue-management") ||
  //     endpoint.includes("/client-feedback") ||
  //     endpoint.includes("/call-records") ||
  //     endpoint.includes("/cold-leads") ||
  //     endpoint.includes("/sales-analytics") ||
  //     endpoint.includes("/sales-updates") ||
  //     endpoint.includes("/si-updates") ||
  //     endpoint.includes("/si-schedules") ||
  //     endpoint.includes("/refund")
  //   ) {
  //     setActiveNavItem("Sales");
  //   } else if (
  //     endpoint.includes("/client-invoice") ||
  //     endpoint.includes("/client-site") ||
  //     endpoint.includes("/client-project") ||
  //     endpoint.includes("/client-payment") ||
  //     endpoint.includes("/client-expense") ||
  //     endpoint.includes("/si-feedback-recieved") ||
  //     endpoint.includes("/site-inspection") ||
  //     endpoint.includes("/client-subsidy-documents") ||
  //     endpoint.includes("/refund") ||
  //     endpoint.includes("/all-revenue-graphs")
  //   ) {
  //     setActiveNavItem("Client");
  //   } else if (
  //     endpoint.includes("/farm") ||
  //     endpoint.includes("/nutrient-calculations") ||
  //     endpoint.includes("/orders-tally") ||
  //     endpoint.includes("/complete-projects") ||
  //     endpoint.includes("/farmer-revenue")
  //     // endpoint.includes("/hydrobuild")
  //   ) {
  //     setActiveNavItem("Farm");
  //   } else if (endpoint.includes("/buyers")) {
  //     setActiveNavItem("Buyers");
  //   } else if (endpoint.includes("/client-employee")) {
  //     setActiveNavItem("Workforce");
  //   } else if (
  //     endpoint.includes("/purchase") ||
  //     endpoint.includes("/project-specification") ||
  //     endpoint.includes("/delivery-challan") ||
  //     endpoint.includes("/material-planning") ||
  //     endpoint.includes("/hydroponic-material-planning") ||
  //     endpoint.includes("/hydroponic-material-inventory") ||
  //     endpoint.includes("/hydroponic-material-planning-table") ||
  //     endpoint.includes("/rfq")
  //   ) {
  //     setActiveNavItem("Purchase");
  //   } else if (endpoint.includes("/agronomy")) {
  //     setActiveNavItem("Agronomy");
  //   } else if (endpoint.includes("/resources")) {
  //     setActiveNavItem("Resources");
  //   } else if (
  //     endpoint.includes("/estimate") ||
  //     endpoint.includes("/client-expense-tracking") ||
  //     endpoint.includes("/client-payment-tracking") ||
  //     endpoint.includes("/client-payment-tracking") ||
  //     endpoint.includes("/credit-notes")
  //   ) {
  //     setActiveNavItem("Account");
  //   } else if (endpoint.includes("/feature-docs")) {
  //     setActiveNavItem("Documentation");
  //   } else {
  //     setActiveNavItem("");
  //   }
  // }, [endpoint]);

  // const closeNavbar = () => {
  //   const navbarMenu = document.getElementById("navbar-menu");
  //   if (navbarMenu && navbarMenu.classList.contains("show")) {
  //     const collapse = new window.bootstrap.Collapse(navbarMenu);
  //     collapse.hide();
  //   }
  // };

  const goToHome = () => {
    navigate("/");
  };

  return (
    <div>
      <div
        className="offcanvas offcanvas-start "
        tabIndex="-1"
        id="offcanvasStart"
        aria-labelledby="offcanvasStartLabel"
        style={{ width: "320px" }}
      >
        <div className="offcanvas-header bg-dark text-light p-3">
          <h2 className="offcanvas-title" id="offcanvasStartLabel">
            <span className="cursor-pointer" onClick={goToHome}>
              {/* <img
                className="navbar-brand-image"
                src="https://www.kryzen.com/wp-content/uploads/2022/02/kryzen-logo-1.png"
                alt="Kryzen"
                style={{
                  width: "110px",
                  height: "50px",
                }}
              /> */}
              <h1 className="fs-large m-0 p-0">
                <span className="text-primary">α</span>
                <span className="text-white">lpha</span>
              </h1>
              <p className="fs-5 ps-6 m-0 text-success">by KRYZEN</p>
            </span>
          </h2>
          <button
            type="button"
            className="btn-close text-reset btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            style={{ fontSize: "20px" }}
          ></button>
        </div>
        <hr className="m-0"></hr>
        <div className="offcanvas-body bg-dark text-light">
          <div className="">
            <ul className="navbar-nav">
              <li className="nav-item ">
                {navBar.includes("Internal") && (
                  <>
                    <div className="accordion-item mb-2">
                      <button
                        className="accordion-header d-flex justify-content-between align-items-center w-100"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                        role="tab"
                        aria-expanded="false"
                      >
                        <div className="d-flex align-items-center">
                          <FcMindMap
                            className="fs-1 me-1"
                            style={{ height: "28px", width: "28px" }}
                          />
                          <span
                            id="k-Internal"
                            className="nav-link-title ms-1 fs-3 p-0"
                          >
                            Internal
                          </span>
                        </div>
                        <IoIosArrowDown size={18}></IoIosArrowDown>
                      </button>
                      <div
                        id="faq-1-1"
                        className="accordion-collapse collapse"
                        role="tabpanel"
                        data-bs-parent="#faq-1"
                      >
                        <div className="accordion-body pt-0">
                          <div className="fs-4 ms-6 mt-1 text-light">
                            {navBar.includes("Employee Management") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/employee-management"
                                style={{ width: "" }}
                              >
                                <FcBusinessman className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Employee Management
                              </NavLink>
                            )}
                            {navBar.includes("Employee Salary") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/verify-salary"
                              >
                                <FcMoneyTransfer className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Employee Salary
                              </NavLink>
                            )}
                            {navBar.includes("Leave Management") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/employee-leave-management"
                              >
                                {" "}
                                <FcCalendar className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Leave Management
                              </NavLink>
                            )}
                            {navBar.includes("Reimbursement Management") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/reimbursement-management"
                              >
                                <FcCalculator className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />{" "}
                                Reimbursement
                              </NavLink>
                            )}
                            {navBar.includes("Attendence Management") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/employee-attendance"
                              >
                                <FcClock className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Attendence Management
                              </NavLink>
                            )}
                            {navBar.includes("Internal FAQ") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/internal-FAQ"
                              >
                                <FcFaq className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Internal FAQ
                              </NavLink>
                            )}
                            {navBar.includes("Task Management") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/task-management"
                              >
                                <FcGenealogy className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Task Management
                              </NavLink>
                            )}
                            {navBar.includes("Marketing List") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/marketing"
                              >
                                <PiListFill
                                  className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                  style={{ color: "green" }}
                                />
                                Marketing List
                              </NavLink>
                            )}

                            {navBar.includes("Mobile App") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/android-app"
                              >
                                <FcAndroidOs className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Android App
                              </NavLink>
                            )}
                            {navBar.includes("Watsapp Logs") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/watsapp-logs"
                              >
                                <IoLogoWhatsapp
                                  className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                  style={{ color: "green" }}
                                />
                                Whatsapp Logs
                              </NavLink>
                            )}
                            {navBar.includes("Employee Feedback") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/employee-feedbacks"
                              >
                                <FcInspection className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Employee Feedback
                              </NavLink>
                            )}
                            {navBar.includes("Company Assets") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/company-assets"
                              >
                                <FcElectronics className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Company Assets
                              </NavLink>
                            )}
                            {navBar.includes("Employee Eficiency Program") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/EEP"
                              >
                                <BsRocket
                                  className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                  style={{ color: "darkorange" }}
                                />
                                EEP
                              </NavLink>
                            )}
                            {navBar.includes("Cricket Game") &&
                              (process.env.REACT_APP_BACKEND_BASEURL?.includes(
                                "localhost"
                              ) ||
                                process.env.REACT_APP_BACKEND_BASEURL?.includes(
                                  "alpha-dev"
                                )) && (
                                <NavLink
                                  className={({ isActive }) =>
                                    isActive
                                      ? "dropdown-item active"
                                      : "dropdown-item"
                                  }
                                  to="/show-teams"
                                >
                                  <span className="fs-2 me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2">
                                    🏏
                                  </span>
                                  Cricket Game
                                </NavLink>
                              )}
                            {navBar.includes("Job Applications") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/show-applications"
                              >
                                <FcStackOfPhotos className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Job Applications
                              </NavLink>
                            )}

                            {navBar.includes("Financial Expense") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/financial-dashboard"
                              >
                                <FcSurvey className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                                Financial Expense
                              </NavLink>
                            )}

                            {navBar.includes("Celebration") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/celebration"
                              >
                                <span className="fs-2 me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2">
                                  🎉
                                </span>
                                Celebration
                              </NavLink>
                            )}

                            {navBar.includes("Scrum Meetings") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/scrum-meetings"
                              >
                                <FcServiceMark className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "></FcServiceMark>
                                Scrum Meetings
                              </NavLink>
                            )}

                            {navBar.includes("Farm Training Media") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                // to="/view-farmTraining-media"
                                to="/get-folders"
                              >
                                <FcMultipleCameras className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "></FcMultipleCameras>
                                Farm Training Media
                              </NavLink>
                            )}

                            {navBar.includes("My Scoreboard") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/my-scoreboard"
                              >
                                <FcMoneyTransfer className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                                My Scoreboard
                              </NavLink>
                            )}
                            {navBar.includes("Training Tests") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/trainees-overview"
                              >
                                <FcSelfServiceKiosk className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                                Training Tests
                              </NavLink>
                            )}
                            {navBar.includes("Template Settings") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/whatsapp-template-setting"
                              >
                                <FcSettings className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                                Template Settings
                              </NavLink>
                            )}
                            {navBar.includes("Campaign Stat") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/campaign-stat"
                              >
                                <FcStatistics className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                                Campaign Stat
                              </NavLink>
                            )}

                            {navBar.includes("Interview Candidates") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/candidates"
                              >
                                <FcReading className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                                Interview Candidates
                              </NavLink>
                            )}
                            {navBar.includes(
                              "Interview Scheduling Pipline"
                            ) && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/interview-schedule-pipeline"
                              >
                                <FcAlarmClock className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                                Interview Scheduling Pipline
                              </NavLink>
                            )}

                            {navBar.includes("Request For Material") && (
                              <NavLink
                                className={({ isActive }) =>
                                  isActive
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                to="/req-for-material"
                              >
                                <FcInTransit className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                                Request For Material
                              </NavLink>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="my-2"></hr>
                  </>
                )}
              </li>
              {navBar.includes("Quotation") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-2"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcRatings
                          className="fs-2  me-1"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-Quotation"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Quotation
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-2"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-2"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Quotation Matrix") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/standard-quotation"
                            >
                              <FcPuzzle className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Quotation Matrix
                            </NavLink>
                          )}
                          {navBar.includes("Custom Quotation") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/custom-quotation"
                            >
                              <FcSurvey className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Custom Quotation
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}
              {navBar.includes("Sales") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header  d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-3"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcPositiveDynamic
                          className="fs-2  me-1"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-Sales"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Sales
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-3"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-3"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Enquiry") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/enquiry"
                            >
                              <FcCustomerSupport className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              Enquiry
                            </NavLink>
                          )}
                          {navBar.includes("My Operator") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/my-operator"
                            >
                              <FcCallback className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              My Operator
                            </NavLink>
                          )}
                          {navBar.includes("Leads System") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/leads-tracking-system"
                            >
                              {" "}
                              <FcCellPhone className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              Leads Tracking
                            </NavLink>
                          )}
                          {navBar.includes("Leads Closer") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/leads-closer"
                            >
                              {" "}
                              <FcProcess className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              Leads Closer
                            </NavLink>
                          )}
                          {navBar.includes("Revenue Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/revenue-management"
                            >
                              <FcBullish className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Revenue Management
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Farm Training") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-training"
                            >
                              <FcLandscape className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Farm Training
                            </NavLink>
                          )}
                          {navBar.includes("Client Feedback") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-feedback"
                            >
                              <FcFeedIn className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Client Feedback
                            </NavLink>
                          )}
                          {navBar.includes("Call Records") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/call-records"
                            >
                              <FcPhone className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Call Records
                            </NavLink>
                          )}
                          {navBar.includes("Analytics") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/sales-analytics"
                            >
                              <FcPieChart className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Performance analytics
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Sales Analytics") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-revenue-overview"
                            >
                              <FcElectricalThreshold className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Sales Analytics
                            </NavLink>
                          )}
                          {navBar.includes("Call Tracking") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/call-tracking"
                            >
                              <FcCallTransfer className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Call Tracking
                            </NavLink>
                          )}
                          {navBar.includes("Sales Updates") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/sales-updates"
                            >
                              <MdOutlineTipsAndUpdates
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "yellow" }}
                              />
                              Sales Updates
                            </NavLink>
                          )}
                          {navBar.includes("SI Updates") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/si-updates"
                            >
                              <FcKindle
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "yellow" }}
                              />
                              SI Updates
                            </NavLink>
                          )}
                          {navBar.includes("SI Schedules") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/si-schedules"
                            >
                              <FcPlanner
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "yellow" }}
                              />
                              SI Schedules
                            </NavLink>
                          )}
                          {navBar.includes("Refund") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/refund"
                            >
                              <FcCurrencyExchange className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Refund
                            </NavLink>
                          )}
                          {navBar.includes("Construction Designer") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/construction-designer"
                            >
                              <FcGrid className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Construction Designer
                            </NavLink>
                          )}
                          {navBar.includes("NHM Applicants") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/nhm-applicants"
                            >
                              <FcVoicePresentation className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              NHM Applicants
                            </NavLink>
                          )}
                          {navBar.includes("NHM Applicants") && (
                            // {navBar.includes("KIT TRACKING") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/kitTracking"
                            >
                              <FcAreaChart className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Kit Tracking
                            </NavLink>
                          )}
                          {navBar.includes("Proforma Invoice") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-invoice"
                            >
                              <FaFileInvoiceDollar className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Proforma Invoice
                            </NavLink>
                          )}
                          {navBar.includes("Create Enquiry") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/create-enquiry"
                            >
                              <FcCustomerSupport className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Create Enquiry
                            </NavLink>
                          )}{" "}
                          {navBar.includes(
                            "MyOperator & JustDial Enquiries"
                          ) && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-justDial-myOperator"
                            >
                              <FcCallback className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              MyOp + JD Enquiries
                            </NavLink>
                          )}
                          {navBar.includes("Leads") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/leads"
                            >
                              {" "}
                              <FcAreaChart className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              Leads
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Leads FollowUp") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/leads-followup"
                            >
                              <FcCallTransfer className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Leads Followup
                            </NavLink>
                          )}
                          {navBar.includes("Cold Leads") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/cold-leads"
                            >
                              <FcDisapprove className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              Cold Leads
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Leads Tracking") && (
                            // lead track
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/leads-tracking"
                            >
                              <FcFlowChart className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Leads Progress
                            </NavLink>
                          )}
                          {navBar.includes("Create Enquiry") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/create-vendor-buy-order"
                            >
                              <FcCustomerSupport className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Vendor Buy Order
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Master Leads") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/leads-master"
                            >
                              <FcNeutralTrading className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Master Leads
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Ai Call Logs") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-ai-call-log"
                            >
                              <FcPhone className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Ai Call Logs
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Lead Transfer") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-leads-transfer"
                            >
                              <FcAdvance className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Lead Transfer
                            </NavLink>
                          )}{" "}
                          {/* {navBar.includes("Ai Bookings") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-ai-bookings"
                            >
                              <FcAcceptDatabase className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Ai Bookings
                            </NavLink>
                          )}{" "} */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}
              {navBar.includes("Media & Marketing") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-17"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcClapperboard
                          className="nav-link-title fs-2 p-0"
                          style={{
                            height: "28px",
                            width: "28px",
                            color: "#3b82f6",
                          }}
                        />

                        <span
                          id="k-docs"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Media & Marketing
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-17"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-17"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Content Pipeline") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/media-content-dashboard"
                            >
                              <FcFinePrint
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Content Pipeline
                            </NavLink>
                          )}
                          {navBar.includes("Posting Planning") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/media-posting"
                            >
                              <FcCalendar
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Posting Planning{" "}
                            </NavLink>
                          )}

                          {navBar.includes("Media Delivery") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-all-media-task"
                            >
                              <FcCamcorderPro
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Media Delivery{" "}
                            </NavLink>
                          )}
                          {navBar.includes("Podcast") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/podcasts"
                            >
                              <FcCollaboration
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Podcast
                            </NavLink>
                          )}

                          {/* {navBar.includes("Reels / Shorts") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-reel-shorts"
                            >
                              <FcCompactCamera
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Reels / Shorts
                            </NavLink>
                          )} */}

                          {/* {navBar.includes("Informative Videos") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-informative-videos"
                            >
                              <FcFilmReel
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Informative Videos
                            </NavLink>
                          )} */}

                          {/* {navBar.includes("Graphics") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-graphics"
                            >
                              <FcEditImage
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Graphics
                            </NavLink>
                          )} */}

                          {navBar.includes("Guest Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/guests"
                            >
                              <FcBusinessman
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Guest Management
                            </NavLink>
                          )}

                          {navBar.includes("Concept & Ideas") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-concept-ideas"
                            >
                              <FcProcess
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Concept & Ideas
                            </NavLink>
                          )}

                          {navBar.includes("Creative Standards & Apps") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/creative-standards"
                            >
                              <FcImport
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Creative Standards & Apps
                            </NavLink>
                          )}

                          {navBar.includes("Courses") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-all-courses"
                            >
                              <FcSelfServiceKiosk
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                              />
                              Courses
                            </NavLink>
                          )}
                          {navBar.includes("Email Marketing") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/email-marketing"
                            >
                              <FcFeedback className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Email Marketing
                            </NavLink>
                          )}

                          {navBar.includes("Email Matrics") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/email-matrics"
                            >
                              <FcBullish className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Email Matrics
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}
              {navBar.includes("Client") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header  d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-4"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcManager
                          className="fs-2  me-1"
                          style={{ height: "28px", width: "28px" }}
                        />
                        <span
                          id="k-ClientManagement"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Clients
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-4"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-4"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Client Projects") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-projects"
                            >
                              {" "}
                              <FcWorkflow className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Client Projects
                            </NavLink>
                          )}

                          {navBar.includes("Site Inspection") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-site-inspection"
                            >
                              <FcPanorama className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Site Inspection
                            </NavLink>
                          )}
                          {navBar.includes("Handover") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-project-handover"
                            >
                              <FcReading className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Handover
                            </NavLink>
                          )}
                          {navBar.includes("Project Tracking") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-project-tracking"
                            >
                              <FcCollect className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Project Tracking
                            </NavLink>
                          )}
                          {navBar.includes("Payment Tracking") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-payment-tracking"
                            >
                              <FcCurrencyExchange className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Payment Tracking
                            </NavLink>
                          )}
                          {navBar.includes("Subsidy & Documents") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-subsidy-documents-upload"
                            >
                              <FcDocument className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Subsidy & Documents
                            </NavLink>
                          )}
                          {navBar.includes("Expence Tracking") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-expense-tracking"
                            >
                              <FcLineChart className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Expence Tracking
                            </NavLink>
                          )}
                          {navBar.includes("SI-Feedback") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/si-feedback-recieved"
                            >
                              <FcInspection className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              SI-Feedback
                            </NavLink>
                          )}
                          {navBar.includes("Completed Projects") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/complete-projects"
                            >
                              <FcOk className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Completed Projects
                            </NavLink>
                          )}
                          {navBar.includes("Agri Subsidy") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-subsidies"
                            >
                              <FcMms className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Agri Subsidy
                            </NavLink>
                          )}
                          {navBar.includes("A. Structure Utilization") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/structure-utilization/"
                            >
                              <FcTemplate className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              A. Structure For Utilization
                            </NavLink>
                          )}
                          {navBar.includes("Labour Training") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/labour-training"
                            >
                              <FcReadingEbook
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "green" }}
                              />
                              Labour Training
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}

              {navBar.includes("Farm") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-5"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcCloseUpMode
                          className="fs-2 me-1"
                          style={{ height: "28px", width: "28px" }}
                        />
                        <span
                          id="k-farm"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Farms
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-5"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-5"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Nursery Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-nursery-management"
                            >
                              <FcStackOfPhotos className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Nursery Management
                            </NavLink>
                          )}
                          {navBar.includes("Farm Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-operations-management"
                            >
                              <FcCircuit className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Farm Management
                            </NavLink>
                          )}
                          {navBar.includes("Water Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-water-management"
                            >
                              <FcDam className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Water Management
                            </NavLink>
                          )}
                          {navBar.includes("Harvest Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-harvest-management"
                            >
                              <PiPlantLight
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "green" }}
                              />
                              Harvest Management
                            </NavLink>
                          )}
                          {navBar.includes("Crop Schedule") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-crop-schedule"
                            >
                              <PiPottedPlantDuotone
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "green" }}
                              />
                              Crop Schedule
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Labour Training") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/labour-training"
                            >
                              <FcReadingEbook
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "green" }}
                              />
                              Labour Training
                            </NavLink>
                          )}{" "}
                          {navBar.includes("Farmer Inventory") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-plants-inventory"
                            >
                              <FcPackage className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Farmer Inventory
                            </NavLink>
                          )}
                          {navBar.includes("Nutrient Calculations") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/nutrient-calculations"
                            >
                              <FcBiomass className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Nutrient Calculations
                            </NavLink>
                          )}
                          {navBar.includes("Farmer Shop") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-shop"
                            >
                              <FcShop className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Farmer Shop
                            </NavLink>
                          )}
                          {navBar.includes("Farmer Orders") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-order"
                            >
                              <FcPaid className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Farmer Orders
                            </NavLink>
                          )}
                          {navBar.includes("Orders Tally") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/orders-tally"
                            >
                              <FcCalculator className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Orders Tally
                            </NavLink>
                          )}
                          {navBar.includes("Orders Revenue") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farmer-revenue"
                            >
                              <FcComboChart className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Farmer Revenue
                            </NavLink>
                          )}
                          {navBar.includes("CnF Inventory") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-cnf-inventory"
                            >
                              <FcPackage className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              CnF Inventory
                            </NavLink>
                          )}
                          {navBar.includes("CnF Shop") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-cnf-shop"
                            >
                              <FcShop className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              CnF Shop
                            </NavLink>
                          )}
                          {navBar.includes("Kryzen Orders") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farm-cnf-order"
                            >
                              <FcPaid className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              CnF Orders
                            </NavLink>
                          )}
                          {navBar.includes("Kryzen Orders") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/kryzen-order"
                            >
                              <FcPaid className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Kryzen Orders
                            </NavLink>
                          )}
                          {/* {navBar.includes("Society Onbording") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-society-onboardings"
                            >
                              <FcOrganization className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Society Onbording
                            </NavLink>
                          )} */}
                          {navBar.includes("EPG Orders") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farmer-epg-dashboard"
                            >
                              <FcOrganization className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              EPG Orders
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}

              {navBar.includes("Farmer Partner") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-5-1"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcCollaboration
                          className="fs-2 me-1"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-farmer-partner"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Farmer Partner
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-5-1"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-5"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Farmer Partner Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farmer-partners"
                            >
                              <FcPaid className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Farmer Partner Management
                            </NavLink>
                          )}
                          {navBar.includes("Society Onbording") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-society-onboardings"
                            >
                              <FcOrganization className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Society Onbording
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}

              {navBar.includes("Buyers Connect") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header  d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-6"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcConferenceCall
                          className="fs-2 me-1"
                          style={{ height: "30px", width: "30px" }}
                        />
                        <span
                          id="k-Buyers"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Buyers Connect
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-6"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-6"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Price Watcher") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/buyers-price-watcher"
                            >
                              <FcSalesPerformance className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Price Watcher
                            </NavLink>
                          )}

                          {navBar.includes("Contract Buying") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/buyers-ltc"
                            >
                              <FcSurvey className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Contract Buying
                            </NavLink>
                          )}

                          {navBar.includes("Buyers Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/buyers-management"
                            >
                              <FcInTransit className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Buyers Management
                            </NavLink>
                          )}

                          {navBar.includes("Price Scrapper") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/price-scrapper"
                            >
                              <FcMultipleInputs className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Price Scrapper
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}
              {/* {navBar.includes("Workforce") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-7"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcReuse
                          className="fs-2 me-1"
                          style={{ height: "28px", width: "28px" }}
                        />
                        <span
                          id="k-Workforce"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Workforce
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-7"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-7"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-employee-database"
                            >
                              <FcTemplate className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Labour Management
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )} */}
              {navBar.includes("Purchase") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header  d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-8"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcShop
                          className="fs-2 me-1"
                          style={{ height: "28px", width: "28px" }}
                        />
                        <span
                          id="k-Purchase"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Purchase
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-8"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-8"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Purchase Order") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/purchase-order"
                            >
                              <FcInvite className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Purchase Order
                            </NavLink>
                          )}

                          {navBar.includes("GRN System") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-grn-items"
                            >
                              <FcFinePrint className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              GRN
                            </NavLink>
                          )}

                          {navBar.includes("Service Order") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/service-order"
                            >
                              <FcSelfServiceKiosk className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Service Order
                            </NavLink>
                          )}
                          {navBar.includes("Request For Quotation") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/rfq"
                            >
                              <FcSurvey className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Request For Quotation
                            </NavLink>
                          )}
                          {navBar.includes("Delivery Challan") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/delivery-challan"
                            >
                              <FcRules className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Delivery Challan
                            </NavLink>
                          )}
                          {navBar.includes("Vendor Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/purchase-vendor-management"
                            >
                              <FcCollaboration className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Vendor Management
                            </NavLink>
                          )}
                          {navBar.includes("Hydroponic Material Planning") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/get-material-lists"
                            >
                              <FcEngineering className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Material Planning
                            </NavLink>
                          )}

                          {navBar.includes("Hydroponic Material Inventory") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/hydroponic-material-inventory"
                            >
                              <MdOutlineInventory
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "green" }}
                              />
                              Material Inventory
                            </NavLink>
                          )}
                          {navBar.includes("Request For Payment") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/req-for-payment/"
                            >
                              <FcMoneyTransfer
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "green" }}
                              />
                              Request For Payment
                            </NavLink>
                          )}
                          {navBar.includes("CEA-NVPH Pricing") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/cea-nvph-pricing"
                            >
                              <CeaNvphPricingIcon size={28} />
                              CEA-Nvph Pricing
                            </NavLink>
                          )}
                          {navBar.includes("Kryzen Store") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/shopify-innventory/"
                            >
                              <FcPaid
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "green" }}
                              />
                              Kryzen Store
                            </NavLink>
                          )}
                          {navBar.includes("Construction Designer") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/construction-designer"
                            >
                              <FcGrid className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Construction Designer
                            </NavLink>
                          )}

                          {navBar.includes("Request For Material") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/req-for-material"
                            >
                              <FcInTransit className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              Request For Material
                            </NavLink>
                          )}

                          {navBar.includes("PO & GRN Vendor Payment") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/Po-Grn-Vendor-Payment"
                            >
                              {/* <FcInTransit className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" /> */}
                              <span className="mt-2">💸 </span>PO & GRN Vendor
                              Payment
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}
              {navBar.includes("Agronomy") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-9"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcPortraitMode
                          className="fs-2 me-1"
                          style={{ height: "28px", width: "28px" }}
                        />
                        <span
                          id="k-Agronomy"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Agronomy
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-9"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-9"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Agronomy Wiki") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/agronomy-plants-wiki"
                            >
                              <FcWikipedia className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Agronomy Wiki
                            </NavLink>
                          )}
                          {navBar.includes("Pest/Disease") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/agronomy-pest-disease"
                            >
                              <MdPestControl
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "brown" }}
                              />
                              Pest/Disease
                            </NavLink>
                          )}

                          {navBar.includes("Farm Support") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/agronomy-farm-support"
                            >
                              <FcSms className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Farm Support
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}

              {navBar.includes("Resources") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-10"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcDeployment
                          className="nav-link-title ms-1 fs-2 p-0"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-Resources"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Resources
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-10"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-10"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Assets") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/resources-assets"
                            >
                              <FcPaid className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2" />
                              Assets
                            </NavLink>
                          )}
                          {navBar.includes("Inventory") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/resources-inventory"
                            >
                              <FcPackage className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Inventory
                            </NavLink>
                          )}
                          {navBar.includes("Management") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-employee-database"
                            >
                              <FcTemplate className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Labour Management
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}
              {navBar.includes("Account") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-11"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcCalculator
                          className="nav-link-title fs-2 p-0"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-accounts"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Accounts
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-11"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-11"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Client Invoice") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-invoice"
                            >
                              <FcFinePrint className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Client Invoices
                            </NavLink>
                          )}
                          {navBar.includes("Estimate") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/estimate"
                            >
                              <FcImport className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Estimate
                            </NavLink>
                          )}
                          {navBar.includes("Payment Tracking") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-payment-tracking"
                            >
                              <FcCurrencyExchange className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Payment Tracking
                            </NavLink>
                          )}
                          {navBar.includes("Expence Tracking") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/client-expense-tracking"
                            >
                              <FcLineChart className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Expense Tracking
                            </NavLink>
                          )}

                          {navBar.includes("Credit Note") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/credit-notes"
                            >
                              <FcNews className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Credit Note
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}

              {navBar.includes("Webinar") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-13"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcIntegratedWebcam
                          className="nav-link-title fs-2 p-0"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-webinar"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Webinar
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-13"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-13"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Webinar") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-webinars"
                            >
                              <FcCamcorderPro className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Webinars
                            </NavLink>
                          )}
                          {navBar.includes("Webinar") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/view-webinar-payments"
                            >
                              <FcCurrencyExchange className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Payments
                            </NavLink>
                          )}

                          {navBar.includes("Webinar") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/webinar/view/webinar-feedback"
                            >
                              <FcInspection className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Webinar Feedbacks
                            </NavLink>
                          )}
                          {navBar.includes("Webinar") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/view-webinar-chats"
                            >
                              <FcComments className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Webinar Chats
                            </NavLink>
                          )}
                          {navBar.includes("Webinar") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-webinars-tickets"
                            >
                              <TicketIcon
                                size={25}
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                              />
                              Webinar Tickets
                            </NavLink>
                          )}
                          {navBar.includes("Webinar") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/webinarInterest"
                            >
                              <FcVideoFile
                                size={25}
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                              />
                              Webinar Interest
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}
              {navBar.includes("Documentation") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-14"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcFinePrint
                          className="nav-link-title fs-2 p-0"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-docs"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Documentation
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-14"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-14"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Website Feature") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/feature-docs"
                            >
                              <FcFlowChart className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              Website Features
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}

              {navBar.includes("Farming Conference") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-15"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcCopyright
                          className="nav-link-title fs-2 p-0"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-docs"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Farming Conference
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-15"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-15"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Farming Conference") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farming-conference"
                            >
                              <FcCurrencyExchange className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 " />
                              FarmingConf Payments
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}

              {navBar.includes("Applications") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-15"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcPaid
                          className="nav-link-title fs-2 p-0"
                          style={{ height: "28px", width: "28px" }}
                        />

                        <span
                          id="k-docs"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          Applications
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-15"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-15"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("Job Applications") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/show-applications"
                            >
                              <HiOutlineDocumentText
                                className="fs-2 me-1"
                                style={{ color: "#22c55e" }}
                              />
                              Job Applications
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}

              {navBar.includes("EPG") && (
                <>
                  <div className="accordion-item mt-2 mb-2">
                    <button
                      className="accordion-header d-flex justify-content-between align-items-center w-100"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq-1-18"
                      role="tab"
                      aria-expanded="false"
                    >
                      <div className="d-flex align-items-center">
                        <FcPaid
                          className="nav-link-title fs-2 p-0"
                          style={{
                            height: "28px",
                            width: "28px",
                            color: "#3b82f6",
                          }}
                        />

                        <span
                          id="k-docs"
                          className="nav-link-title ms-1 fs-3 p-0"
                        >
                          EPG
                        </span>
                      </div>
                      <IoIosArrowDown size={18}></IoIosArrowDown>
                    </button>
                    <div
                      id="faq-1-18"
                      className="accordion-collapse collapse"
                      role="tabpanel"
                      data-bs-parent="#faq-18"
                    >
                      <div className="accordion-body pt-0  text-light">
                        <div className="fs-4 ms-6 mt-1">
                          {navBar.includes("EPG") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/epg-dashboard"
                            >
                              <FcLineChart
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2 "
                                style={{ color: "#22c55e" }}
                              />
                              Dashboard
                            </NavLink>
                          )}
                          {navBar.includes("EPG") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-epg-product"
                            >
                              <HiOutlineDocumentText
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                                size={20}
                              />
                              EPG Product Inventory
                            </NavLink>
                          )}

                          {navBar.includes("EPG") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/all-epg-recipe"
                            >
                              <FcBiomass
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                                size={20}
                              />
                              EPG Recipe Inventory
                            </NavLink>
                          )}

                          {navBar.includes("EPG") && (
                            <NavLink
                              className={({ isActive }) =>
                                isActive
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              to="/farmer-partners"
                            >
                              <FcConferenceCall
                                className="fs-2  me-1 mt-0 mb-0 mt-lg-2 mb-lg-2 mt-md-2 mb-md-2"
                                style={{ color: "#22c55e" }}
                                size={20}
                              />
                              Farmer Partners
                            </NavLink>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2"></hr>
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebarnew;
